export default "__VITE_ASSET__08752608__"